import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_1033",
  "use": "icon-su_1033-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_1033\"><defs><style>#icon-su_1033 .cls-1{fill:none;opacity:0;}#icon-su_1033 .cls-2{fill:#777;}</style></defs><g id=\"icon-su_1033_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_1033_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><polygon class=\"cls-2\" points=\"12 12.81 22 6.45 22 5 2 5 2 6.45 12 12.81\" /><polygon class=\"cls-2\" points=\"12 15.19 2 8.82 2 19 22 19 22 8.82 12 15.19\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol